import React from 'react';
import { IonText } from '@ionic/react';
import PendingPaymentCard from './PendingPaymentCard';

interface IProps {
    payments: any[];
}

const PendingPayments: React.FC<IProps> = (props) => {
    return (
        <>
            {Array.isArray(props.payments) && props.payments.map((payment, index) => <PendingPaymentCard payment={payment} key={index} />)}
            {(!Array.isArray(props.payments) || props.payments.length === 0) && (
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: '48px 24px', gap: '8px' }}>
                    <IonText color="medium" style={{ fontSize: '14px' }}>No payments found</IonText>
                    <IonText color="medium" style={{ fontSize: '13px' }}>Pull to refresh</IonText>
                </div>
            )}
        </>
    );
};

export default PendingPayments;
